import { FileCard } from '../../components/FileCard/FileCard'
import { useUploadingFiles } from '../../hooks'
import { getFileExtensionFromMimeType } from '../../utils'

const UploadingFilesList = () => {
  const uploadingFiles = useUploadingFiles()

  if (uploadingFiles.length === 0) {
    return null
  }

  return (
    <>
      {uploadingFiles.map((file) => {
        const { fileKey, fileName, fileMimeType } = file
        return (
          <FileCard
            key={fileKey}
            fileId={fileKey}
            fileName={fileName}
            fileType={getFileExtensionFromMimeType(fileMimeType)}
            isFileUploading={true}
            isExpanded={false}
            onExpandToggle={() => {}}
          />
        )
      })}
    </>
  )
}

export { UploadingFilesList }
